<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("motivo-despesa") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("despesas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'des-motivo-despesa-list',
                                            })
                                        "
                                        >{{ $t("motivo-despesa") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({ name: 'des-motivo-despesa-list' })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !motivodespesaIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving || motivoDespesas.situacao == 0"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div>
                    <div class="columns">
                        <div class="column is-2">
                            <v-input
                                v-model="motivoDespesas.iddespesa_motivoerp"
                                :id="generateId(23)"
                                ref="iddespesa_motivoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div
                            class="column is-4"
                            style="height: 65px !important"
                        >
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="motivoDespesas.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                :title="'descricao'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!motivoDespesas.descricao"
                                uppercase
                                :required="true"
                            />
                        </div>
                        <div
                            class="column is-3"
                            v-show="
                                motivoDespesas.situacao == 1 ||
                                !$route.params.id
                            "
                        >
                            <label>
                                {{ $t("despesa-automatica-km") }}
                                <b-icon
                                    :disabled="
                                        motivoDespesas.situacao == 0 ||
                                        !$route.params.id
                                    "
                                    icon="information"
                                    size="is-small"
                                    v-tippy 
                                    :title="$t('despesa-automatica-km-label')"
                                />
                            </label>
                            <br />
                            <vss-select
                                :id="generateId(2)"
                                v-model="optionDepsAuto"
                                :options="modosDespesaDeslocamento"
                                :selectHeight="36"
                                label="label"
                                mlLabels
                                @input="updateOptionDepsAuto"
                            />
                        </div>
                        <div
                            class="column is-3"
                            v-show="
                                motivoDespesas.situacao == 1 ||
                                !$route.params.id
                            "
                        >
                            <verified-date-picker
                                :id="generateId(3)"
                                ref="datainicialauto"
                                :value="motivoDespesas.datainicialauto"
                                :title="'data-inicio'"
                                :tooltip="true"
                                :tooltipValue="'data-hora-inicial-despesa-automatica'"
                                :tooltipPosition="'is-bottom'"
                                :required="optionDepsAuto.id == 1"
                                :invalid="
                                    !motivoDespesas.datainicialauto &&
                                    optionDepsAuto.id == 1
                                "
                                :addDateYears="10"
                                :subtractDateYears="4"
                                @input="changeStartDate"
                                :disabled="optionDepsAuto.id != 1"
                                :inForm="true"
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-3">
                            <label>{{ $t("icone") }}</label>
                            <IconsSelect
                                :id="generateId(4)"
                                @changeIcon="motivoDespesas.icone = $event"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="invalidIcon"
                                :iconClass="motivoDespesas.icone"
                            ></IconsSelect>
                        </div>
                        <div class="column is-3">
                            <label for="color">{{
                                $t("selecione-uma-cor")
                            }}</label>
                            <color-picker
                                :id="generateId(5)"
                                type="text"
                                :color="motivoDespesas.cor"
                                ref="cpInput"
                                @colorpicked="motivoDespesas.cor = $event"
                            />
                        </div>
                        <div class="column is-3">
                            <label>
                                {{ $t("qtde-min-foto") }}
                                <b-icon
                                    :disabled="
                                        motivoDespesas.situacao == 0 ||
                                        !$route.params.id
                                    "
                                    icon="information"
                                    size="is-small"
                                    v-tippy 
                                    :title="$t(
                                        'qtde-minima-foto-desconsiderada-sem-obriga'
                                    )"
                                />
                            </label>
                            <v-input
                                :id="generateId(6)"
                                msg="msg-campo-obrigatorio"
                                :invalid="!motivoDespesas.qtdeminimafoto"
                                placeholder="placeholder-preencha"
                                v-model="motivoDespesas.qtdeminimafoto"
                                ref="qtdeMinFotoInput"
                                :useMask="true"
                                :vMask="['##']"
                            />
                        </div>
                        <div class="column is-3">
                            <label>
                                {{ $t("valor-maximo") }}
                                <b-icon
                                    :disabled="
                                        motivoDespesas.situacao == 0 ||
                                        !$route.params.id
                                    "
                                    icon="information"
                                    size="is-small"
                                    v-tippy 
                                    :title="$t('label-valor-maximo-zero')"
                                />
                            </label>
                            <v-money
                                :id="generateId(7)"
                                ref="valorMaximoInput"
                                placeholder="placeholder-preencha"
                                :msg="'msg-campo-obrigatorio'"
                                :maxlength="50"
                                v-model="motivoDespesas.valormaximo"
                            >
                            </v-money>
                        </div>
                    </div>
                    <div class="box">
                        <div class="columns is-flex-wrap">
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("odometro")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(8)"
                                        :type="
                                            checks.odometro.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.odometro.habilita"
                                        @click="changeCheckHabilita('odometro')"
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(9)"
                                        :type="
                                            checks.odometro.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.odometro.obriga"
                                        @click="changeCheckObriga('odometro')"
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("kmpercorrido")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(10)"
                                        :type="
                                            checks.distancia.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.distancia.habilita"
                                        :disabled="optionDepsAuto.id == 2"
                                        @click="
                                            changeCheckHabilita('distancia')
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(11)"
                                        :type="
                                            checks.distancia.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.distancia.obriga"
                                        :disabled="optionDepsAuto.id == 2"
                                        @click="changeCheckObriga('distancia')"
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("placa-veiculo")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(12)"
                                        :type="
                                            checks.placaveiculo.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.placaveiculo.habilita
                                        "
                                        @click="
                                            changeCheckHabilita('placaveiculo')
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(13)"
                                        :type="
                                            checks.placaveiculo.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.placaveiculo.obriga"
                                        @click="
                                            changeCheckObriga('placaveiculo')
                                        "
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>

                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("centrocusto")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(14)"
                                        :type="
                                            checks.centrocusto.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.centrocusto.habilita"
                                        @click="
                                            changeCheckHabilita('centrocusto')
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(15)"
                                        :type="
                                            checks.centrocusto.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.centrocusto.obriga"
                                        @click="
                                            changeCheckObriga('centrocusto')
                                        "
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("fotos")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(16)"
                                        :type="
                                            checks.foto.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.foto.habilita"
                                        @click="changeCheckHabilita('foto')"
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(17)"
                                        :type="
                                            checks.foto.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.foto.obriga"
                                        @click="changeCheckObriga('foto')"
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("observacao")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(18)"
                                        :type="
                                            checks.observacao.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.observacao.habilita"
                                        @click="
                                            changeCheckHabilita('observacao')
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(19)"
                                        :type="
                                            checks.observacao.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.observacao.obriga"
                                        @click="changeCheckObriga('observacao')"
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("estabelecimento")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(20)"
                                        :type="
                                            checks.estabelecimento.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.estabelecimento.habilita
                                        "
                                        @click="
                                            changeCheckHabilita(
                                                'estabelecimento'
                                            )
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(21)"
                                        :type="
                                            checks.estabelecimento.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.estabelecimento.obriga
                                        "
                                        @click="
                                            changeCheckObriga('estabelecimento')
                                        "
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("forma-pagamento")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(20)"
                                        :type="
                                            checks.forma_pagamento.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.forma_pagamento.habilita
                                        "
                                        @click="
                                            changeCheckHabilita(
                                                'forma_pagamento'
                                            )
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(21)"
                                        :type="
                                            checks.forma_pagamento.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.forma_pagamento.obriga
                                        "
                                        @click="
                                            changeCheckObriga('forma_pagamento')
                                        "
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-one-quarter">
                                <label class="label-medium">{{
                                    $t("soliciar-reembolso")
                                }}</label>
                                <div class="group-buttons">
                                    <b-button
                                        :id="generateId(20)"
                                        :type="
                                            checks.solicitar_reembolso.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.solicitar_reembolso.habilita
                                        "
                                        @click="
                                            changeCheckHabilita(
                                                'solicitar_reembolso'
                                            )
                                        "
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        :id="generateId(21)"
                                        :type="
                                            checks.solicitar_reembolso.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="
                                            !checks.solicitar_reembolso.obriga
                                        "
                                        @click="
                                            changeCheckObriga('solicitar_reembolso')
                                        "
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoDespesasService from "@/services/despesas/MotivoDespesasService";
import MotivoDespesasValidation from "@/services/validations/despesas/MotivoDespesasValidation";
import IconsSelect from "@/components/shared/form/IconsSelect";
import ColorPicker from "@/components/shared/form/ColorPicker";
import Message from "@/models/Message";

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    data() {
        return {
            motivodespesaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("DESPESA_MOTIVO"),
            countId: 0,
            variaveis: [],
            service: new MotivoDespesasService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            // invalidDataInicioAuto: false,
            validation: new MotivoDespesasValidation(this.msgs),
            motivoDespesas: {
                iddespesa_motivo: null,
                iddespesa_motivoerp: null,
                descricao: null,
                icone: "",
                cor: "#D0CFCF",
                qtdeminimafoto: "0",
                valormaximo: 0,
                despesaautomatica: 0,
                odometrohabilita: 0,
                odometroobriga: 0,
                distanciahabilita: 0,
                distanciaobriga: 0,
                placahabilita: 0,
                placaobriga: 0,
                centrocustohabilita: 0,
                centrocustoobriga: 0,
                fotohabilita: 0,
                fotoobriga: 0,
                obshabilita: 0,
                obsobriga: 0,
                estabelecimentohabilita: 0,
                estabelecimentoobriga: 0,
                forma_pagamentohabilita: 0,
                forma_pagamentoobriga: 0,
                solicitar_reembolsohabilita: 0,
                solicitar_reembolsoobriga: 0,
                datainicialauto: null,
            },
            modosDespesaDeslocamento: [
                { id: 0, label: "desligado" },
                { id: 1, label: "despesa-automatica-km-maps" },
                { id: 2, label: "despesa-automatica-km-manual" },
            ],
            optionDepsAuto: { id: 0, label: "desligado" },
            checks: {
                odometro: { habilita: false, obriga: false },
                distancia: { habilita: false, obriga: false },
                placaveiculo: { habilita: false, obriga: false },
                centrocusto: { habilita: false, obriga: false },
                foto: { habilita: false, obriga: false },
                observacao: { habilita: false, obriga: false },
                estabelecimento: { habilita: false, obriga: false },
                forma_pagamento: { habilita: false, obriga: false },
                solicitar_reembolso: { habilita: false, obriga: false },
            },
            invalidIcon: false,
            isUpdate: false,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "des-motivo-despesa"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivo-despesa" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados();
                this.isUpdate = true;
            }
        }

    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        changeCheckHabilita(v) {
            this.checks[v].habilita = !this.checks[v].habilita;
            if (!this.checks[v].habilita) this.checks[v].obriga = false;
        },
        changeCheckObriga(v) {
            this.checks[v].obriga = !this.checks[v].obriga;
            if (this.checks[v].obriga) this.checks[v].habilita = true;
        },

        changeStartDate(date) {
            this.motivoDespesas.datainicialauto = date;
            this.invalidDataInicioAuto =
                (this.motivoDespesas.datainicialauto == null);
        },
        updateOptionDepsAuto() {
            if (this.optionDepsAuto.id == 2) {
                this.checks["distancia"].obriga = true;
                this.checks["distancia"].habilita = true;
            }
        },
        carregarDados() {
            this.isLoading = true;

            this.$axios
                .get(`/despesa/despesamotivo/${this.$route.params.id}.json`)
                .then((response) => {
                    this.motivoDespesas = response.data.content;
                    
                    if (this.motivoDespesas.datainicialauto != null)
                        this.motivoDespesas.datainicialauto = this.$moment(
                            this.motivoDespesas.datainicialauto
                        ).toDate();
                    // Passa checks para form
                    this.checks.odometro.habilita =
                        this.motivoDespesas.odometrohabilita == 1;
                    this.checks.odometro.obriga =
                        this.motivoDespesas.odometroobriga == 1;
                    this.checks.distancia.habilita =
                        this.motivoDespesas.distanciahabilita == 1;
                    this.checks.distancia.obriga =
                        this.motivoDespesas.distanciaobriga == 1;
                    this.checks.placaveiculo.habilita =
                        this.motivoDespesas.placahabilita == 1;
                    this.checks.placaveiculo.obriga =
                        this.motivoDespesas.placaobriga == 1;
                    this.checks.centrocusto.habilita =
                        this.motivoDespesas.centrocustohabilita == 1;
                    this.checks.centrocusto.obriga =
                        this.motivoDespesas.centrocustoobriga == 1;
                    this.checks.foto.habilita =
                        this.motivoDespesas.fotohabilita == 1;
                    this.checks.foto.obriga =
                        this.motivoDespesas.fotoobriga == 1;
                    this.checks.observacao.habilita =
                        this.motivoDespesas.obshabilita == 1;
                    this.checks.observacao.obriga =
                        this.motivoDespesas.obsobriga == 1;
                    this.checks.estabelecimento.habilita =
                        this.motivoDespesas.estabelecimentohabilita == 1;
                    this.checks.estabelecimento.obriga =
                        this.motivoDespesas.estabelecimentoobriga == 1;
                    this.checks.forma_pagamento.habilita =
                        this.motivoDespesas.forma_pagamentohabilita == 1;
                    this.checks.forma_pagamento.obriga =
                        this.motivoDespesas.forma_pagamentoobriga == 1;
                    this.checks.solicitar_reembolso.habilita =
                        this.motivoDespesas.solicitar_reembolsohabilita == 1;
                    this.checks.solicitar_reembolso.obriga =
                        this.motivoDespesas.solicitar_reembolsoobriga == 1;
                })
                .catch((error) => {
                    this.$root.msgs.push(new Message('error', 'msg-erro-load'));
                })
                .finally((_) => {
                    this.isLoading = false;

                    this.optionDepsAuto = this.modosDespesaDeslocamento.find((v) => {
                        if (v.id == this.motivoDespesas.despesaautomatica) return v;
                    });
                });
        },
        save() {
            this.isLoading = true;

            if (!this.motivoDespesas.valormaximo) this.motivoDespesas.valormaximo = 0.0;
            
            this.motivoDespesas.despesaautomatica = this.optionDepsAuto.id;

            if (
                this.validation.validate(this.motivoDespesas, this.$refs) &&
                this.motivoDespesas.icone != ""
            ) {
                let motivoDespesasTemp = Object.assign({}, this.motivoDespesas);
                motivoDespesasTemp = this.mapTosave(motivoDespesasTemp);

                motivoDespesasTemp.datainicialauto =
                    motivoDespesasTemp.datainicialauto
                        ? this.$moment(motivoDespesasTemp.datainicialauto).format("YYYY-MM-DD")
                        : null;
                // Passa checks para form
                motivoDespesasTemp.odometrohabilita = this.checks.odometro
                    .habilita
                    ? 1 : 0;
                motivoDespesasTemp.odometroobriga = this.checks.odometro.obriga
                    ? 1 : 0;
                motivoDespesasTemp.distanciahabilita = this.checks.distancia
                    .habilita
                    ? 1 : 0;
                motivoDespesasTemp.distanciaobriga = this.checks.distancia
                    .obriga
                    ? 1 : 0;
                motivoDespesasTemp.placahabilita = this.checks.placaveiculo
                    .habilita
                    ? 1 : 0;
                motivoDespesasTemp.placaobriga = this.checks.placaveiculo.obriga
                    ? 1 : 0;
                motivoDespesasTemp.centrocustohabilita = this.checks.centrocusto
                    .habilita
                    ? 1 : 0;
                motivoDespesasTemp.centrocustoobriga = this.checks.centrocusto
                    .obriga
                    ? 1 : 0;
                motivoDespesasTemp.fotohabilita = this.checks.foto.habilita
                    ? 1 : 0;
                motivoDespesasTemp.fotoobriga = this.checks.foto.obriga ? 1 : 0;
                motivoDespesasTemp.obshabilita = this.checks.observacao.habilita
                    ? 1 : 0;
                motivoDespesasTemp.obsobriga = this.checks.observacao.obriga
                    ? 1 : 0;
                motivoDespesasTemp.forma_pagamentohabilita = this.checks
                    .forma_pagamento.habilita
                    ? 1 : 0;
                motivoDespesasTemp.forma_pagamentoobriga = this.checks
                    .forma_pagamento.obriga
                    ? 1 : 0;
                motivoDespesasTemp.solicitar_reembolsohabilita = this.checks
                    .solicitar_reembolso.habilita
                    ? 1 : 0;
                motivoDespesasTemp.solicitar_reembolsoobriga = this.checks
                    .solicitar_reembolso.obriga
                    ? 1 : 0;
                motivoDespesasTemp.estabelecimentohabilita = this.checks
                    .estabelecimento.habilita
                    ? 1 : 0;
                motivoDespesasTemp.estabelecimentoobriga = this.checks
                    .estabelecimento.obriga
                    ? 1 : 0;

                this.invalidIcon = false;
                this.isSaving = true;
                motivoDespesasTemp.iddespesa_motivoerp = this.motivoDespesas.iddespesa_motivoerp;
                this.service
                    .save(motivoDespesasTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "msg-save-motivo-despesas";
                            if (this.motivoDespesas.idmotivodespesas != null) {
                                msg = "msg-edit-motivo-despesas";
                            }
                            this.msgs.push(new Message("success", msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body && !this.isNull(e.body.message) && this.$te(e.body.message)) {
                            this.$root.msgs.push(
                                new Message("alert", this.$t(e.body.message), true, false)
                            );
                        } else {
                            this.$root.msgs.push(
                                new Message("error", "msg-problema-realizar-acao", true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                this.invalidIcon = (this.motivoDespesas.icone == "");
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.idmotivodespesas,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "des-motivo-despesa-list",
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .box {
        background-color: #fdfdfd;
    }
}
</style>
